export const MESSAGE_WAITING_IDS = {
  user: "ai-message-user-waiting",
  assistant: "ai-message-assistant-waiting",
};
